import dragState from '@/store/modules/sessionState/uiOperations/dragState';
import selections from '@/store/modules/sessionState/uiOperations/selections';
import touchState from '@/store/modules/sessionState/uiOperations/touchState';

export default {
    dragState,
    selections,
    touchState,
};
